module.exports = __webpack_public_path__ + "img/9788957981221.1d7d9b32.jpg";